import { Popconfirm, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { FaEdit, FaTrash } from "react-icons/fa";
import { MdApartment, MdEmail, MdPhone, MdCalendarToday } from "react-icons/md";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";
import { getAsociaciones, deleteAsociacion } from 'services/Asociaciones';
import Loader from 'components/loader';

const formatDate = (value) => value ? new Date(value).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

const TableAssociations = ({ onEdit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [asociaciones, setAsociaciones] = useState([]);

  useEffect(() => {
    obtenerAsociaciones();
  }, []);

  async function obtenerAsociaciones() {
    setIsLoading(true);
    const data = await getAsociaciones();
    setAsociaciones(Array.isArray(data) ? data : []);
    setIsLoading(false);
  }

  const handleEdit = (asociacion) => {
    if (onEdit) onEdit([asociacion]);
  };

  const handleDelete = async (id) => {
    await deleteAsociacion(id);
    obtenerAsociaciones();
  };

  if (isLoading) {
    return <Loader />;
  }

  if (asociaciones.length === 0) {
    return <p className="text-sm text-gray-600 dark:text-gray-400">No hay asociaciones cargadas</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
      {asociaciones.map((asociacion) => {
        const vigente = asociacion.fecha_hasta ? new Date(asociacion.fecha_hasta) >= new Date() : true;

        return (
          <div
            key={asociacion.id}
            className="flex flex-col gap-3 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-navy-700 dark:bg-navy-800"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="text-gray-600 dark:text-gray-300"><MdApartment size={20} /></span>
                <h3 className="text-base font-bold text-navy-700 dark:text-white">{asociacion.nombre}</h3>
              </div>
              <div className="flex shrink-0 items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleEdit(asociacion)}
                  className="text-gray-400 transition duration-200 hover:text-brand-500"
                >
                  <FaEdit />
                </button>
                <Popconfirm
                  title="Eliminar asociación"
                  description="¿Está seguro que desea eliminar esta asociación?"
                  onConfirm={() => handleDelete(asociacion.id)}
                  okText="Si"
                  cancelText="No"
                  okButtonProps={{ className: "bg-blue-500" }}
                >
                  <button type="button" className="text-gray-400 transition duration-200 hover:text-cancelado">
                    <FaTrash />
                  </button>
                </Popconfirm>
              </div>
            </div>

            <Tag color={vigente ? "green" : "red"} className="w-fit">
              {vigente ? "Vigente" : "Vencida"}
            </Tag>

            <div className="flex flex-col gap-1.5 text-sm text-navy-700 dark:text-white">
              {asociacion.nombre_contacto && (
                <p className="font-semibold">{asociacion.nombre_contacto}</p>
              )}
              {asociacion.email && (
                <p className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                  <MdEmail className="shrink-0" /> {asociacion.email}
                </p>
              )}
              {asociacion.telefono && (
                <p className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                  <MdPhone className="shrink-0" /> {asociacion.telefono}
                </p>
              )}
              <p className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                <MdCalendarToday className="shrink-0" /> {formatDate(asociacion.fecha_desde)} — {formatDate(asociacion.fecha_hasta)}
              </p>
              {asociacion.observaciones && (
                <p className="mt-1 text-xs italic text-gray-500 dark:text-gray-400">{asociacion.observaciones}</p>
              )}
            </div>

            <Link
              to={`${routesNames.INSTITUCIONES}?asociacion_id=${asociacion.id}`}
              className="mt-2 w-fit rounded-lg bg-lightPrimary px-3 py-2 text-sm font-semibold text-navy-700 transition duration-200 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20"
            >
              Ver instituciones asignadas →
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default TableAssociations;
